import {reactive} from 'vue'
import ApiService from '@/core/services/ApiService'
import {endpoints} from '@/core/services/Endpoints'
import {getModuleIdByCode} from '@/core/services/Helper'
import panelManager from '@/core/helpers/panelManager'

const REFRESH_INTERVAL = 15 * 60 * 1000

const state = reactive({
    pendingCount: 0,
    dockBadge: true,
})

let _timer = null
let _initialized = false

async function fetchPendingCount() {
    const moduleId = getModuleIdByCode('AGENDA')
    if (!moduleId) return
    try {
        const res = await ApiService.axios.post(endpoints.module_widget, {
            widgets: [{module_id: moduleId, code: 'DAILY_SUMMARY'}],
        })
        const items = res.data?.data
        if (Array.isArray(items)) {
            const widget = items.find(w => w.code === 'DAILY_SUMMARY')
            if (widget?.data) {
                state.pendingCount = widget.data.pending ?? 0
            }
        }
    } catch { /* empty */ }
}

function init() {
    if (_initialized) return
    _initialized = true
    fetchPendingCount()
    _timer = setInterval(fetchPendingCount, REFRESH_INTERVAL)
}

function destroy() {
    if (!_initialized) return
    _initialized = false
    clearInterval(_timer)
    _timer = null
}

function _saveDockBadge() {
    const saved = panelManager.loadLayout('agendaPanel')
    panelManager.saveLayout('agendaPanel', {...saved, dockBadge: state.dockBadge})
}

function restoreSettings() {
    if (state._settingsRestored) return
    state._settingsRestored = true
    const saved = panelManager.loadLayout('agendaPanel')
    if (saved.dockBadge != null) state.dockBadge = saved.dockBadge
}

function toggleDockBadge() {
    state.dockBadge = !state.dockBadge
    _saveDockBadge()
}

function refresh() {
    fetchPendingCount()
}

export default {state, init, destroy, toggleDockBadge, refresh, restoreSettings}
